import yup from 'yup';

import mapConnection from '../../../utils/connectionMapper';
import { noUTC } from '../../DateAndTimeInputs';
import { UpdateClaim } from '../../../mutations/UpdateClaim';

const initialClaimForm = {
  passengerTicket: {
    passengerFirstName: '',
    passengerLastName: ''
  },
  flights: [
    {
      number: '',
      airline: '',
      airportOrigin: '',
      airportDestination: '',
      localArrivalDate: undefined,
      localDepartureDate: undefined
    }
  ]
};

const ERROR_REQUIRED = 'This field is required';

export const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: ({ claim }) => {
    if (claim) {
      const currentClaim = {
        ...initialClaimForm,
        passengerTicketId: claim.passengerTicketId,
        flightId: claim.flightId,
        passengers: mapConnection(claim.claimsPassengerTicketConnection).map(
          p => ({
            ...p.passengerTicket
          })
        ),
        flights: mapConnection(claim.flightsPassengerTicketsConnection).map(
          ({ flight }) => ({
            ...flight,
            airline: flight.airline.iata,
            airportOrigin: flight.airportOrigin.iata,
            airportDestination: flight.airportDestination.iata,
            localArrivalDate: noUTC(flight.localArrivalDate),
            localDepartureDate: noUTC(flight.localDepartureDate)
          })
        ),
        id: claim.codeClaim
      };
      return { ...currentClaim };
    }
    return { ...initialClaimForm };
  },
  validationSchema: () => {
    return yup.object().shape({
      flights: yup.array().of(
        yup.object().shape({
          airportOrigin: yup.string().required(ERROR_REQUIRED),
          airportDestination: yup.string().required(ERROR_REQUIRED),
          airline: yup.string().required(ERROR_REQUIRED),
          localDepartureDate: yup.string().required(ERROR_REQUIRED),
          localArrivalDate: yup.string().required(ERROR_REQUIRED)
        })
      ),
      passengers: yup.array().of(
        yup.object().shape({
          passengerFirstName: yup.string().required(ERROR_REQUIRED),
          passengerLastName: yup.string().required(ERROR_REQUIRED)
        })
      )
    });
  },
  handleSubmit: (values, { props, setErrors, setSubmitting }) => {
    const { flights, passengers, secretToken, passengerTicketId } = values;

    const updatedFlights = flights.map(flight => ({
      id: flight.id,
      airlineCode: flight.airline,
      localDepartureDate: flight.localDepartureDate,
      localArrivalDate: flight.localArrivalDate,
      airportOriginCode: flight.airportOrigin,
      airportDestinationCode: flight.airportDestination
    }));
    const updatedPassengers = passengers.map(passenger => ({
      id: passenger.id,
      pnr: passenger.pnr,
      passengerFirstName: passenger.passengerFirstName,
      passengerLastName: passenger.passengerLastName
    }));

    const input = {
      claim: {
        id: props.claim.id,
        token: secretToken,
        passengerTicketId
      },
      taskId: props.task.id,
      passengerTickets: updatedPassengers,
      flights: updatedFlights
    };
    props.client
      .mutate({
        mutation: UpdateClaim,
        variables: {
          input: input
        }
      })
      .then(() => {
        setSubmitting(false);
        props.onTaskComplete();
      })
      .catch(() => {
        window.scrollTo(0, 0);
        setSubmitting(false);
      });
  }
};



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/formikConfig.js